<template>
    <div class="step-layout">
        <!-- Step Intro Section -->
        <section class="step-layout-left bg-1">
            <div class="step-layout-container">
                <h2 class="text-white intro-title d-none d-sm-block" v-html="bannerTitle"></h2>
                <h2 class="text-white intro-title d-block d-sm-none text-center" v-html="bannerMobileTitle"></h2>
                <div class="text-center text-sm-left">
                    <a href="javascript:void(0)" class="btn btn-primary d-none" @click="goBack()">
                        <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                    </a>
                </div>
            </div>
        </section>
        <!-- Step Form Section -->
        <section class="step-layout-right">
            <div class="step-layout-container">
                <h2 class="heading_section title" v-html="valuationTitle"></h2>
                <form class="text-center" action="#">
                    <div class="form-group input-group-lg text-left">
                        <input type="text" v-model="name" name="full_name" class="form-control" :class="$v.name.$error
                                ? 'is-invalid'
                                : $v.name.required
                                    ? 'is-valid'
                                    : ''
                            " @input="$v.name.$touch()" placeholder="Full name" />
                        <div class="text-left invalid-feedback" v-if="$v.name.$error">
                            Name is required
                        </div>
                    </div>
                    <div class="form-group input-group-lg text-left">
                        <input type="email" v-model="email" name="email_addr" class="form-control" :class="$v.email.$error
                                ? 'is-invalid'
                                : $v.email.required && $v.email.email
                                    ? 'is-valid'
                                    : ''
                            " @input="$v.email.$touch()" placeholder="E-mail" />
                        <div class="text-left invalid-feedback" v-if="$v.email.$error">
                            <template v-if="!$v.email.required">Email is required</template>
                            <template v-else-if="!$v.email.email">Email must be a valid email address</template>
                        </div>
                    </div>
                    <div class="form-group input-group-lg text-left">
                        <input type="text" v-model="phone" name="phone_no" class="form-control" :class="$v.phone.$error
                                ? 'is-invalid'
                                : $v.phone.required &&
                                    $v.phone.canadianNumber
                                    ? 'is-valid'
                                    : ''
                            " @input="$v.phone.$touch()" placeholder="Phone" />
                        <div class="text-left invalid-feedback" v-if="$v.phone.$error">
                            <template v-if="!$v.phone.required">Phone number is required</template>
                            <template v-else-if="!$v.phone.canadianNumber">Phone number must be a canadian
                                number</template>
                        </div>
                    </div>
                    <div class="text-left text-lg-right submit-btn-wrapper">
                        <button type="button" class="button_layout submit-btn" @click="submitForm">
                            Continue
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
const canadaPhoneFormat = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
const canadianNumber = (value) => canadaPhoneFormat.test(value);
export default {
    name: "DirectPropertyValuationStepOne",
    data() {
        return {
            valuationStep: 1,
            selectedCity: "Toronto",
            selectedAddress: "",
            name: "",
            email: "",
            phone: "",
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "First Step",
            valuationTitle:
                "We require your information to provide accurate valuations!",
        };
    },
    computed: {
        stepOneInvalid() {
            if (
                this.$v.name.$invalid ||
                this.$v.email.$invalid ||
                this.$v.phone.$invalid
            ) {
                return true;
            } else {
                return false;
            }
        },
        bannerTitle() {
            let title =
                "Real estate board require that we </br>verify your information to get full access to our sold listings data base.";
            return title;
        },
        bannerMobileTitle() {
            let title =
                "Real estate board require that we verify your information to get full access to our sold listings data base.";
            return title;
        },
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        if (sessionStorage.getItem("valuation_name")) {
            this.name = sessionStorage.getItem("valuation_name");
        }
        if (sessionStorage.getItem("valuation_email")) {
            this.email = sessionStorage.getItem("valuation_email");
        }
        if (sessionStorage.getItem("valuation_phone")) {
            this.phone = sessionStorage.getItem("valuation_phone");
        }
        if (sessionStorage.getItem("valuation_utm_source")) {
            this.utm_source = sessionStorage.getItem("valuation_utm_source");
        }
        if (sessionStorage.getItem("valuation_utm_medium")) {
            this.utm_medium = sessionStorage.getItem("valuation_utm_medium");
        }
        if (sessionStorage.getItem("valuation_utm_campaign")) {
            this.utm_campaign = sessionStorage.getItem(
                "valuation_utm_campaign"
            );
        }
        if (sessionStorage.getItem("valuation_utm_id")) {
            this.utm_id = sessionStorage.getItem("valuation_utm_id");
        }
        if (sessionStorage.getItem("valuation_utm_content")) {
            this.utm_content = sessionStorage.getItem("valuation_utm_content");
        }
        if (sessionStorage.getItem("valuation_data")) {
            sessionStorage.removeItem("valuation_data");
        }
    },
    validations: {
        name: {
            required,
        },
        email: {
            required,
            email,
        },
        phone: {
            required,
            canadianNumber,
        },
    },
    methods: {
        submitForm() {
            this.$v.$touch();
            if (!this.stepOneInvalid) {
                sessionStorage.setItem("valuation_name", this.name);
                sessionStorage.setItem("valuation_email", this.email);
                sessionStorage.setItem("valuation_phone", this.phone);

                const formData = new FormData();

                formData.append("utm_id", this.utm_id);
                formData.append("utm_source", this.utm_source);
                formData.append("utm_medium", this.utm_medium);
                formData.append("utm_campaign", this.utm_campaign);
                formData.append("utm_content", this.utm_content);

                formData.append("address", this.selectedAddress);
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.phone);
                formData.append("extra_info", "First Step");

                if (this.selectedAddress) {
                    axios
                        .post("/direct-leads/submit-leads", formData)
                        .then((response) => {
                            console.log(response.data);
                        })
                        .catch((error) => {
                            console.error(error);
                        })
                        .finally((result) => {
                            this.$emit("goToNext");
                        });
                }
                else {
                    this.$emit("goToNext");
                }
            }
        },
        goBack() {
            window.location.href = "/";
        },
        selectHomeType(type) {
            this.propertyType = type;
        },
        selectSellFrequency(frequency) {
            this.sellFrequency = frequency;
        },
        setBasementPresent(present) {
            this.basePresent = present;
        },
        setAnotherHouseBuyPlan(plan) {
            this.anotherHouseBuyPlan = plan;
        },
    },
};
</script>

<style scoped>
    button:disabled {
        cursor: not-allowed;
    }
    .form-control:focus,
    .form-control:active,
    .form-control:active,
    .form-control:visited {
        outline: none;
    }
</style>
